module.exports = __webpack_public_path__ + "img/star-fill-active.e5495f96.svg";